import { Injectable, EventEmitter } from '@angular/core';
@Injectable(
    {providedIn: 'root'}
)
export class EmitterService {
    public reloadMainDashBoard: EventEmitter<any>;
    public setActiveMenu: EventEmitter<any>;
    public getOpenExceptionCount: EventEmitter<any>;
    public setActiveSymbolEvent: EventEmitter<any>;
    public setActiveCodeEvent: EventEmitter<any>;
    public setActiveSymbolTypeEvent: EventEmitter<any>;
    public ResetQuickFilterPanelEvent: EventEmitter<any>;
    public ReloadQuickFilterPanelEvent: EventEmitter<any>;
    public isOrderViewerOpenCloseEvent: EventEmitter<any>;
    public isODROrderViewerOpenCloseEvent: EventEmitter<any>;
    public isResetGridLimit: EventEmitter<any>;
    public exportToCSVData: EventEmitter<any>;
    public onMouseOutMainWindow: EventEmitter<any>;
    public ActiveCustomSampleFilterQuery:EventEmitter<any>;
    constructor() {
        this.reloadMainDashBoard = new EventEmitter();
        this.setActiveMenu = new EventEmitter();
        this.getOpenExceptionCount = new EventEmitter();
        this.setActiveSymbolEvent = new EventEmitter();
        this.setActiveCodeEvent = new EventEmitter();
        this.setActiveSymbolTypeEvent = new EventEmitter();
        this.ResetQuickFilterPanelEvent = new EventEmitter();
        this.ReloadQuickFilterPanelEvent = new EventEmitter();
        this.isOrderViewerOpenCloseEvent =new EventEmitter();
        this.isResetGridLimit = new EventEmitter();
        this.exportToCSVData = new EventEmitter();
        this.onMouseOutMainWindow = new EventEmitter();
        this.ActiveCustomSampleFilterQuery = new EventEmitter();
        this.isODROrderViewerOpenCloseEvent = new EventEmitter();
    }
}
